import React from 'react';
import { Linkedin, ExternalLink } from 'lucide-react';
import { consultants } from '../data/mock';

const ConsultantsSection = ({ id }) => {
  return (
    <section id={id} className="section-padding bg-gradient-to-b from-transparent to-bg-card/20">
      <div className="container">
        {/* Section Header */}
        <div className="text-center mb-16 fade-in-up">
          <div className="inline-flex items-center gap-2 glass-card px-4 py-2 text-sm text-brand-primary border border-brand-primary/20 mb-6">
            <span>Nossa Equipe</span>
          </div>
          <h2 className="heading-1 mb-6">
            Nossos <span className="text-brand-primary">Consultores</span>
          </h2>
          <div className="w-20 h-1 bg-brand-primary rounded-full mx-auto mb-8"></div>
          <p className="body-large max-w-3xl mx-auto">
            Conheça os especialistas por trás dos projetos que transformam 
            ideias em produtos excepcionais.
          </p>
        </div>

        {/* Consultants Grid */}
        <div className="grid sm:grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8 max-w-4xl mx-auto">
          {consultants.map((consultant, index) => (
            <div 
              key={consultant.id}
              className="glass-card group hover:border-brand-primary/30 transition-all duration-500 overflow-hidden"
              style={{ animationDelay: `${index * 0.2}s` }}
            >
              {/* Image Section */}
              <div className="relative h-64 bg-gradient-to-br from-brand-primary/10 to-transparent overflow-hidden">
                {consultant.image && consultant.image !== "/api/placeholder/300/300" ? (
                  <img 
                    src={consultant.image} 
                    alt={consultant.name}
                    className="w-full h-full object-cover"
                  />
                ) : (
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-32 h-32 bg-brand-primary/20 rounded-full border-2 border-brand-primary/30 flex items-center justify-center">
                      <div className="text-4xl font-bold text-brand-primary">
                        {consultant.name.split(' ').map(n => n[0]).join('')}
                      </div>
                    </div>
                  </div>
                )}
                
                {/* Overlay Effect */}
                <div className="absolute inset-0 bg-gradient-to-t from-bg-card/80 to-transparent opacity-0 group-hover:opacity-100 transition-all duration-300"></div>
                
                {/* LinkedIn Button */}
                <div className="absolute top-4 right-4 opacity-0 group-hover:opacity-100 transition-all duration-300 transform translate-y-2 group-hover:translate-y-0">
                  <a
                    href={consultant.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-10 h-10 bg-brand-primary text-text-inverse rounded-full flex items-center justify-center hover:scale-110 transition-transform"
                  >
                    <Linkedin size={16} />
                  </a>
                </div>
              </div>

              {/* Content Section */}
              <div className="p-6">
                <div className="mb-4">
                  <h3 className="heading-3 text-xl mb-2 group-hover:text-brand-primary transition-colors">
                    {consultant.name}
                  </h3>
                  <p className="body-small text-text-secondary leading-relaxed">
                    {consultant.role}
                  </p>
                </div>

                {/* LinkedIn Link */}
                <a
                  href={consultant.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-brand-primary hover:text-brand-hover transition-colors group/link"
                >
                  <Linkedin size={16} />
                  <span className="text-sm">Ver perfil no LinkedIn</span>
                  <ExternalLink size={12} className="group-hover/link:translate-x-1 transition-transform" />
                </a>
              </div>
            </div>
          ))}
        </div>

        {/* Team Values */}
        <div className="mt-16">
          <div className="glass-card p-8 text-center">
            <h3 className="heading-2 text-xl lg:text-2xl mb-6">
              Expertise e <span className="text-brand-primary">Dedicação</span>
            </h3>
            <p className="body-medium max-w-3xl mx-auto leading-relaxed">
              Nossa equipe combina anos de experiência em design com paixão por inovação. 
              Cada projeto é uma oportunidade de criar soluções que fazem a diferença na vida das pessoas.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ConsultantsSection;